import React from "react";
import { Facebook, Instagram, Twitter, X } from "lucide-react";
const XTwitterIcon = () => (
  <svg viewBox="0 0 1200 1227" fill="currentColor" width="12" height="12">
    <path d="M714.163 519.284L1160.89 0H1055.53L667.137 451.887L356.711 0H0L468.492 681.821L0 1226.37H105.355L515.239 750.218L842.999 1226.37H1199.71L714.137 519.284H714.163Z" />
  </svg>
);
const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-border">
        <div className="footer-container">
          <div className="footer-wrapper">
            {/* Desktop Left Section */}
            <div className="footer-left">
              <div className="social-icons">
                <a
                  target="_blank"
                  className="social-links"
                  href="https://www.facebook.com/share/16t8itRSnC/"
                >
                  <div className="ftdiamond">
                    <Facebook size={16} />
                  </div>
                </a>
                <a
                  target="_blank"
                  className="social-links"
                  href="https://www.instagram.com/houseofbombaynj?igsh=aWE0OTdycTNrZ2Z1"
                >
                  <div className="ftdiamond">
                    <Instagram size={16} />
                  </div>
                </a>

                {/* <a target="_blank" className="social-links" href="#">
                  <div className="ftdiamond">
                    <XTwitterIcon />
                  </div>
                </a> */}
              </div>

              <div className="footer-menu">
                <a href="/">HOME</a>
                <a href="/about-us">ABOUT US</a>
                <a href="/our-menu">OUR MENU</a>
                <a href="/reservations">RESERVATIONS</a>

                <a href="/careers">CAREERS</a>
              </div>
            </div>

            {/* Desktop Right Section */}
            <div className="footer-right">
              <div>
                <a href="/">
                  <img
                    src="/hob_logo.png"
                    alt="House of Bombay"
                    className="footer-logo"
                  />
                </a>
                <p className="phone">
                  <a href="tel:17323531224" className="phone">
                    +1 732-353-1224
                  </a>
                </p>
                <p className="email">
                  <a href="mailto:info@houseofbombay.us" className="email">
                    info@houseofbombay.us
                  </a>
                </p>
              </div>
            </div>

            {/* Mobile Footer Left */}
            <div className="mobile-footer-left">
              <div className="footer-menu">
                <ul>
                  <li>
                    <a href="/">HOME</a>
                  </li>
                  <li>
                    <a href="/about-us">ABOUT US</a>
                  </li>
                  <li>
                    <a href="/our-menu">OUR MENU</a>
                  </li>
                  <li>
                    <a href="/reservations">RESERVATIONS</a>
                  </li>
                  <li>
                    <a href="/careers">CAREERS</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mobile-footer-right">
              <div>
                <a href="/">
                  <img
                    src="/hob_logo.png"
                    alt="House of Bombay"
                    className="footer-logo"
                  />
                </a>
                <p className="phone">
                  <a href="tel:17323531224" className="phone">
                    +1 732-353-1224
                  </a>
                </p>
                <p className="email">
                  <a href="mailto:info@houseofbombay.us" className="email">
                    info@houseofbombay.us
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="mobile-social-icons">
            <a
              target="_blank"
              className="social-links"
              href="https://www.facebook.com/share/16t8itRSnC/"
            >
              <div className="ftdiamond">
                <Facebook size={16} />
              </div>
            </a>
            <a
              target="_blank"
              className="social-links"
              href="https://www.instagram.com/houseofbombaynj?igsh=aWE0OTdycTNrZ2Z1"
            >
              <div className="ftdiamond">
                <Instagram size={16} />
              </div>
            </a>
          </div>
        </div>
        <div className="footer_brands">
          <span>FROM THE SAME HOUSE </span>
          <div className="footer_brands_images">
            <a
              target="_blank"
              className="social-links"
              href="https://www.instagram.com/nomimumbai?igsh=dHZoODl5aXZ1NnF3"
            >
              <div className="">
                <img
                  src="/nomi.png"
                  style={{ width: "80px", background: "#6D4402" }}
                />
              </div>
            </a>
            <a
              target="_blank"
              className="social-links"
              href="https://www.instagram.com/rasmanthanindia?igsh=ZDY5cG5vbGk3dDR6"
            >
              <div className="">
                <img src="/rasmanthan.jpg" style={{ width: "80px" }} />
              </div>
            </a>
            <a
              target="_blank"
              className="social-links"
              href="https://www.instagram.com/theterrace.amaidenaffair?igsh=d3M0cDBwbXJrNWlz"
            >
              <div className="">
                <img src="/theterrace.jpg" style={{ width: "80px" }} />
              </div>
            </a>
          </div>
        </div>
        {/* Bottom Copyright */}
        <div className="footer-bottom">
          <div className="footer-bottom-border">
            © Copyright House of Bombay 2026
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
